import { createFileRoute } from "@tanstack/react-router"
import { ProjectDocumentsPage } from "@/pages/contracten/contract_detail/ProjectDocuments"

export const Route = createFileRoute("/beheer/contracten/$contractId/dossier/")(
  {
    component: RouteComponent,
  },
)

function RouteComponent() {
  const { contractId } = Route.useParams()

  return <ProjectDocumentsPage projectId={Number(contractId)} />
}
